import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconBrandADManager(props: IconProps) {
  return (
    <BaseIcon size={40} {...props}>
      <path
        d="M15.68 3.035c7.436 5.216 4.325 17.26-3.567 18.565 10.092 0 13.43-13.962 3.566-18.565Z"
        fill="#FFCE26"
      />
      <path
        d="M7.787 2.958c8.802-1.304 12.445 9.666 8.575 14.73 6.374-6.445 1.29-17.952-8.575-14.73Z"
        fill="#0879B8"
      />
      <path
        d="M2.627 8.251c4.325-6.52 13.355-2.531 14.266 4.066C17.955 4.262 7.332-.264 2.627 8.251Z"
        fill="#069B4F"
      />
      <path
        d="M2.4 13.161c1.062-6.75 9.713-7.441 12.9-2.685C12.72 3.725 2.552 4.57 2.4 13.161Z"
        fill="#CB2034"
      />
    </BaseIcon>
  );
}
